export default "__VITE_ASSET__BrxOHzJp__"